import { CompiledChartTimeSetup } from '@/composables/charts/influx-charts/chart-serialization/ChartTimeSetup'
import { CHART_TYPES } from '@/composables/charts/influx-charts/chart-builders/CHART_TYPES'
import type DataTransformPlugin from '@/composables/charts/influx-charts/DataTransformPlugin'
import NightVisionTransformPlugin from '@/composables/charts/influx-charts/data-transform-plugins/NightVisionTransformPlugin'
import { CompiledInfluxQueryObject, InfluxQuery, TagSelector } from '@/composables/charts/influx-charts/query-builders/InfluxTypes'
import { SerializedIRChart } from '@/composables/charts/influx-charts/chart-builders/ChartInterfaces'
import { InfluxChartBuilder } from '@/composables/charts/influx-charts/chart-builders/InfluxChartBuilder'

export class IRInfluxChartBuilder extends InfluxChartBuilder {
  cameraTagSelector: TagSelector<'camera'>
  protected readonly dataTransformPlugins: DataTransformPlugin[] = [new NightVisionTransformPlugin()]

  constructor(serialized: SerializedIRChart) {
    super(serialized)
    this.cameraTagSelector = serialized.cameraTagSelector
  }

  serialize(): SerializedIRChart {
    return {
      ...super.serialize(),
      xAggregation: 'first',
      chartType: CHART_TYPES.IR,
      cameraTagSelector: this.cameraTagSelector,
    }
  }

  buildQuery(): CompiledInfluxQueryObject {
    const compiledTimeSetup: CompiledChartTimeSetup = this.timeSetup.compile()
    const query: InfluxQuery = {
      time: {
        start: compiledTimeSetup.start,
        end: compiledTimeSetup.end,
      },
      timeResolution: compiledTimeSetup.timeResolution + 'ms',
      columns: {
        nightvision: 'first@y',
      },
      groupByTags: ['camera'],
    }

    if (this.whereClauses) {
      query.where = this.whereClauses
    }
    if (!query.where && !this.cameraTagSelector.useAll && this.cameraTagSelector.specificValues && this.cameraTagSelector.specificValues.length > 0) {
      query.where = { camera: this.cameraTagSelector.specificValues }
    }
    if (this.fill !== undefined) {
      query.fill = this.fill
    }
    return {
      path: '/api/data/imageQuality',
      query: [query],
    }
  }
  getRenderChartType(): string {
    return 'xrange'
  }
  autoInferChartEntity(): string | undefined {
    return 'frontend-charts.ir'
  }
}
